import React, { useContext } from "react";
import "./landing.css";
import { Link } from 'react-router-dom';
import Navbar from '../layouts/navbar';
import Mascot from "../../assets/img/MascotSVG1.svg";
import { AuthContext } from '../../auth';

const LandingPage = () => {

  const [logedinuser] = useContext(AuthContext);
  console.log(logedinuser);
  var data;
  if (logedinuser == null) {
    data = 
      <div className='container-fluid'>
        <p className='login'>
          Already an existing user? <Link to='/login'> Log In</Link>
        </p>
        <p className='signup mb-0'>
          If not, <Link to='/register'> Sign Up</Link>
        </p>
      </div>
      
  }else{
    data = <div></div>
  }

  return (
    <div>

      <Navbar head="Connection Aid"></Navbar>
      <div style={{marginTop:"50px"}}>
        {/* <Header /> */}

        {/* //   mascot */}

        <div className='container-fluid'>
          <img className="mascot" src={Mascot} alt="mascot"></img>
        </div>
        <div className='container-fluid about_section'>
          <h2 className='sub-heading1'>Creating Connections,</h2>
          <h3 className='sub-heading2'>Harvesting Health</h3>
          <p>
            Our goal is to provide guidance towards an informed deaddiction
            programme.
          </p>
          <div className='container-fluid'>
            <Link to="/explore"><button className='btn btn-primary'>Explore</button></Link>
            <Link to="/chat"><button className='btn btn-primary'>Let's talk </button></Link>
          </div>
          {data}
        </div>
      </div>
    </div>
  );
}

export default LandingPage;
